/**
 * Whether the pre-purchase quantity warning notice should be visible.
 *
 * `quantity` is the variant inventory quantity.
 *
 * @param {number} totalQty
 * @param {number} variantInventoryQuantity
 * @param {string} method
 * @returns {boolean}
 */
export function shouldShowQuantityWarningNotice(totalQty, variantInventoryQuantity, method = 'normal') {
    if (method === 'inverse') {
        return Number.isFinite(totalQty) && totalQty > 0 && totalQty <= variantInventoryQuantity;
    }
    return Number.isFinite(totalQty) && totalQty > 0 && totalQty > variantInventoryQuantity;
}

// <quantity-warning-notice> and <quantity-warning-inverse-notice> toggle their own visibility. Binding modes:
//   1. Inside a <sqft-calculator> (sqft / lf / box MTO): listens to the
//      calculator's `sqft:change` event and reads detail.boxesNeeded.
function defineQuantityWarningNotice(tagName, method) {
    class QuantityWarningNoticeElement extends HTMLElement {
        connectedCallback() {
            let calculator = this.closest('sqft-calculator');
            if (!calculator) {
                const calculators = document.querySelectorAll('sqft-calculator');
                if (calculators.length === 1) {
                    calculator = calculators[0];
                }
            }
            if (!calculator) return;
            const variantInventoryQuantity = this.getAttribute('data-variant-inventory-quantity');
            if (!variantInventoryQuantity) return;
            const calculatorHandler = (event) => {
                this._toggle(
                    event.detail && (event.detail.boxesNeeded || event.detail.totalSqft),
                    parseInt(variantInventoryQuantity)
                );
            };
            this._calculator = calculator;
            this._calculatorHandler = calculatorHandler;
            calculator.addEventListener('sqft:change', calculatorHandler);
        }

        disconnectedCallback() {
            if (this._calculator && this._calculatorHandler) {
                this._calculator.removeEventListener('sqft:change', this._calculatorHandler);
            }
        }

        _toggle(totalQty, variantInventoryQuantity) {
            this.hidden = !shouldShowQuantityWarningNotice(totalQty, variantInventoryQuantity, method);
        }
    }

    if (!window.customElements.get(tagName)) {
        window.customElements.define(tagName, QuantityWarningNoticeElement);
    }
}

defineQuantityWarningNotice('quantity-warning-notice', 'normal');
defineQuantityWarningNotice('quantity-warning-inverse-notice', 'inverse');
